// extracted by mini-css-extract-plugin
export default {"topLocations":"_2lVe2","noSidePadding":"_2JePH"};